// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__xjOZn","menuItem":"Menu_menuItem__Bbu5m"};